module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAARVBMVEUAAABkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRmZmZmZmZkZGRkZGRkZGT////Y291kZGSNjo9ra2uanJzV2NqXmJmKi4y8VcuhAAAADnRSTlMAWg53njLlsRn0897cdbLJn2wAAACLSURBVFjD7ddrCoUgEIbhOSe7X5yu+19q/yIbFcwgpO9ZwAuK4AwBJEux1FZEJVsosuNFC9uP/pOWFnZFtDQ6ItoTYdMR4Qt/ZDg7RQYDIoggkl7EdCsivBOhepbWIjCSZxZ5WMQjPhJ/nD70OI31YlN9J/gBEUHke5GIYThuLH9+QVAsde5VBSBVO3QLdB1qcB2HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/programme/images/Scenicspot_icon_01.png
// module id = YIwE
// module chunks = 1